import { baseApi as api } from './baseApi';

const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApiV1ClientAdFeatures: build.query<
            GetApiV1ClientAdFeaturesApiResponse,
            GetApiV1ClientAdFeaturesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/AdFeatures`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientAdFeaturesById: build.query<
            GetApiV1ClientAdFeaturesByIdApiResponse,
            GetApiV1ClientAdFeaturesByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/AdFeatures/${queryArg.id}` }),
        }),
        getApiV1ClientAdFeaturesGetPricingByIdById: build.query<
            GetApiV1ClientAdFeaturesGetPricingByIdByIdApiResponse,
            GetApiV1ClientAdFeaturesGetPricingByIdByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/AdFeatures/GetPricingById/${queryArg.id}`,
            }),
        }),
        getApiV1ClientAds: build.query<GetApiV1ClientAdsApiResponse, GetApiV1ClientAdsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/client/Ads`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    status: queryArg.status,
                    propertyType: queryArg.propertyType,
                    maintenanceStatuses: queryArg.maintenanceStatuses,
                    advertOwnerType: queryArg.advertOwnerType,
                    advertType: queryArg.advertType,
                    documentStatus: queryArg.documentStatus,
                    mortgageStatus: queryArg.mortgageStatus,
                    priceType: queryArg.priceType,
                    buildingType: queryArg.buildingType,
                    minPrice: queryArg.minPrice,
                    maxPrice: queryArg.maxPrice,
                    minPropertyArea: queryArg.minPropertyArea,
                    maxPropertyArea: queryArg.maxPropertyArea,
                    minPropertyFloor: queryArg.minPropertyFloor,
                    maxPropertyFloor: queryArg.maxPropertyFloor,
                    countryIds: queryArg.countryIds,
                    cityIds: queryArg.cityIds,
                    districtIds: queryArg.districtIds,
                    metroIds: queryArg.metroIds,
                    targetIds: queryArg.targetIds,
                    roomCount: queryArg.roomCount,
                    sortByPrimary: queryArg.sortByPrimary,
                    sortDirectionPrimary: queryArg.sortDirectionPrimary,
                    sortBySecondary: queryArg.sortBySecondary,
                    sortDirectionSecondary: queryArg.sortDirectionSecondary,
                    agencyId: queryArg.agencyId,
                    isVIP: queryArg.isVip,
                    isPremium: queryArg.isPremium,
                },
            }),
        }),
        postApiV1ClientAds: build.mutation<PostApiV1ClientAdsApiResponse, PostApiV1ClientAdsApiArg>(
            {
                query: (queryArg) => ({
                    url: `/api/v1/client/Ads`,
                    method: 'POST',
                    body: queryArg.body,
                }),
            },
        ),
        getApiV1ClientAdsGetAllCurrentUserAds: build.query<
            GetApiV1ClientAdsGetAllCurrentUserAdsApiResponse,
            GetApiV1ClientAdsGetAllCurrentUserAdsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Ads/GetAllCurrentUserAds`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    status: queryArg.status,
                },
            }),
        }),
        getApiV1ClientAdsById: build.query<
            GetApiV1ClientAdsByIdApiResponse,
            GetApiV1ClientAdsByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/Ads/${queryArg.id}` }),
        }),
        putApiV1ClientAdsById: build.mutation<
            PutApiV1ClientAdsByIdApiResponse,
            PutApiV1ClientAdsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Ads/${queryArg.id}`,
                method: 'PUT',
                body: queryArg.body,
            }),
        }),
        deleteApiV1ClientAdsById: build.mutation<
            DeleteApiV1ClientAdsByIdApiResponse,
            DeleteApiV1ClientAdsByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/Ads/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiV1ClientAdsGetUserBalance: build.query<
            GetApiV1ClientAdsGetUserBalanceApiResponse,
            GetApiV1ClientAdsGetUserBalanceApiArg
        >({
            query: () => ({ url: `/api/v1/client/Ads/GetUserBalance` }),
        }),
        putApiV1ClientAdsReactivateAdsById: build.mutation<
            PutApiV1ClientAdsReactivateAdsByIdApiResponse,
            PutApiV1ClientAdsReactivateAdsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Ads/ReactivateAds/${queryArg.id}`,
                method: 'PUT',
                params: {
                    payWithBalance: queryArg.payWithBalance,
                },
            }),
        }),
        getApiV1ClientAdsCreateRole: build.query<
            GetApiV1ClientAdsCreateRoleApiResponse,
            GetApiV1ClientAdsCreateRoleApiArg
        >({
            query: () => ({ url: `/api/v1/client/Ads/CreateRole` }),
        }),
        getApiV1ClientAdsByIdPdf: build.query<
            GetApiV1ClientAdsByIdPdfApiResponse,
            GetApiV1ClientAdsByIdPdfApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Ads/${queryArg.id}/pdf`,
                params: {
                    withContact: queryArg.withContact,
                },
            }),
        }),
        getApiV1ClientAdvertisements: build.query<
            GetApiV1ClientAdvertisementsApiResponse,
            GetApiV1ClientAdvertisementsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Advertisements`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientAgencies: build.query<
            GetApiV1ClientAgenciesApiResponse,
            GetApiV1ClientAgenciesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Agencies`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientAgenciesById: build.query<
            GetApiV1ClientAgenciesByIdApiResponse,
            GetApiV1ClientAgenciesByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/Agencies/${queryArg.id}` }),
        }),
        postApiV1ClientAuthResetPassword: build.mutation<
            PostApiV1ClientAuthResetPasswordApiResponse,
            PostApiV1ClientAuthResetPasswordApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Auth/ResetPassword`,
                method: 'POST',
                body: queryArg.darxApplicationDtOsAuthDtOsResetPasswordDto,
            }),
        }),
        getApiV1ClientAuthVerifyPasswordResetToken: build.query<
            GetApiV1ClientAuthVerifyPasswordResetTokenApiResponse,
            GetApiV1ClientAuthVerifyPasswordResetTokenApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Auth/VerifyPasswordResetToken`,
                params: {
                    userId: queryArg.userId,
                    resetToken: queryArg.resetToken,
                },
            }),
        }),
        postApiV1ClientAuthUpdatePasswordAsync: build.mutation<
            PostApiV1ClientAuthUpdatePasswordAsyncApiResponse,
            PostApiV1ClientAuthUpdatePasswordAsyncApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Auth/UpdatePasswordAsync`,
                method: 'POST',
                body: queryArg.darxApplicationDtOsAuthDtOsUpdatePasswordDto,
            }),
        }),
        getApiV1ClientAuthRefreshTokenLoginAsync: build.query<
            GetApiV1ClientAuthRefreshTokenLoginAsyncApiResponse,
            GetApiV1ClientAuthRefreshTokenLoginAsyncApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Auth/RefreshTokenLoginAsync`,
                params: {
                    refreshToken: queryArg.refreshToken,
                },
            }),
        }),
        getApiV1ClientBlogs: build.query<GetApiV1ClientBlogsApiResponse, GetApiV1ClientBlogsApiArg>(
            {
                query: (queryArg) => ({
                    url: `/api/v1/client/Blogs`,
                    params: {
                        pageNumber: queryArg.pageNumber,
                        pageSize: queryArg.pageSize,
                        isPaginated: queryArg.isPaginated,
                    },
                }),
            },
        ),
        getApiV1ClientBlogsById: build.query<
            GetApiV1ClientBlogsByIdApiResponse,
            GetApiV1ClientBlogsByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/Blogs/${queryArg.id}` }),
        }),
        getApiV1ClientBuildingTypes: build.query<
            GetApiV1ClientBuildingTypesApiResponse,
            GetApiV1ClientBuildingTypesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/BuildingTypes`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientCities: build.query<
            GetApiV1ClientCitiesApiResponse,
            GetApiV1ClientCitiesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Cities`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    countryId: queryArg.countryId,
                },
            }),
        }),
        postApiV1ClientContactsCallMe: build.mutation<
            PostApiV1ClientContactsCallMeApiResponse,
            PostApiV1ClientContactsCallMeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Contacts/call-me`,
                method: 'POST',
                body: queryArg.darxApplicationDtOsContactsDtoCallMeRequestDto,
            }),
        }),
        getApiV1ClientCountries: build.query<
            GetApiV1ClientCountriesApiResponse,
            GetApiV1ClientCountriesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Countries`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientCurrencies: build.query<
            GetApiV1ClientCurrenciesApiResponse,
            GetApiV1ClientCurrenciesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Currencies`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientCurrenciesById: build.query<
            GetApiV1ClientCurrenciesByIdApiResponse,
            GetApiV1ClientCurrenciesByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/Currencies/${queryArg.id}` }),
        }),
        getApiV1ClientDistricts: build.query<
            GetApiV1ClientDistrictsApiResponse,
            GetApiV1ClientDistrictsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Districts`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    cityId: queryArg.cityId,
                },
            }),
        }),
        postApiV1ClientIdentityRegister: build.mutation<
            PostApiV1ClientIdentityRegisterApiResponse,
            PostApiV1ClientIdentityRegisterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/Register`,
                method: 'POST',
                body: queryArg.darxApplicationDtOsIdentityDtOsRegisterDto,
            }),
        }),
        putApiV1ClientIdentityUpdate: build.mutation<
            PutApiV1ClientIdentityUpdateApiResponse,
            PutApiV1ClientIdentityUpdateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/Update`,
                method: 'PUT',
                body: queryArg.body,
            }),
        }),
        getApiV1ClientIdentityGetCurrentUser: build.query<
            GetApiV1ClientIdentityGetCurrentUserApiResponse,
            GetApiV1ClientIdentityGetCurrentUserApiArg
        >({
            query: () => ({ url: `/api/v1/client/Identity/GetCurrentUser` }),
        }),
        postApiV1ClientIdentityLogin: build.mutation<
            PostApiV1ClientIdentityLoginApiResponse,
            PostApiV1ClientIdentityLoginApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/Login`,
                method: 'POST',
                body: queryArg.darxApplicationDtOsIdentityDtOsLoginDto,
            }),
        }),
        postApiV1ClientIdentitySendOtp: build.mutation<
            PostApiV1ClientIdentitySendOtpApiResponse,
            PostApiV1ClientIdentitySendOtpApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/SendOtp`,
                method: 'POST',
                params: {
                    phoneNumber: queryArg.phoneNumber,
                },
            }),
        }),
        postApiV1ClientIdentityVerifyOtp: build.mutation<
            PostApiV1ClientIdentityVerifyOtpApiResponse,
            PostApiV1ClientIdentityVerifyOtpApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/VerifyOtp`,
                method: 'POST',
                params: {
                    phoneNumber: queryArg.phoneNumber,
                    otpCode: queryArg.otpCode,
                },
            }),
        }),
        postApiV1ClientIdentityVerifyOtpForAds: build.mutation<
            PostApiV1ClientIdentityVerifyOtpForAdsApiResponse,
            PostApiV1ClientIdentityVerifyOtpForAdsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Identity/VerifyOtpForAds`,
                method: 'POST',
                params: {
                    phoneNumber: queryArg.phoneNumber,
                    otpCode: queryArg.otpCode,
                },
            }),
        }),
        getApiV1ClientLanguages: build.query<
            GetApiV1ClientLanguagesApiResponse,
            GetApiV1ClientLanguagesApiArg
        >({
            query: () => ({ url: `/api/v1/client/Languages` }),
        }),
        getApiV1ClientMetros: build.query<
            GetApiV1ClientMetrosApiResponse,
            GetApiV1ClientMetrosApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Metros`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    cityId: queryArg.cityId,
                },
            }),
        }),
        postApiV1ClientPaymentsInitializeAdsUpgradePayment: build.mutation<
            PostApiV1ClientPaymentsInitializeAdsUpgradePaymentApiResponse,
            PostApiV1ClientPaymentsInitializeAdsUpgradePaymentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/InitializeAdsUpgradePayment`,
                method: 'POST',
                params: {
                    adsId: queryArg.adsId,
                    adFueaturePricingId: queryArg.adFueaturePricingId,
                },
            }),
        }),
        postApiV1ClientPaymentsInitializeIncreaseBalancePayment: build.mutation<
            PostApiV1ClientPaymentsInitializeIncreaseBalancePaymentApiResponse,
            PostApiV1ClientPaymentsInitializeIncreaseBalancePaymentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/InitializeIncreaseBalancePayment`,
                method: 'POST',
                params: {
                    amount: queryArg.amount,
                },
            }),
        }),
        postApiV1ClientPaymentsInitializePayWithBalancePayment: build.mutation<
            PostApiV1ClientPaymentsInitializePayWithBalancePaymentApiResponse,
            PostApiV1ClientPaymentsInitializePayWithBalancePaymentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/InitializePayWithBalancePayment`,
                method: 'POST',
                params: {
                    adsId: queryArg.adsId,
                    adFueaturePricingId: queryArg.adFueaturePricingId,
                },
            }),
        }),
        getApiV1ClientPaymentsVerifyPayment: build.query<
            GetApiV1ClientPaymentsVerifyPaymentApiResponse,
            GetApiV1ClientPaymentsVerifyPaymentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/VerifyPayment`,
                params: {
                    transaction: queryArg.transaction,
                },
            }),
        }),
        getApiV1ClientPaymentsGetUserPurchasesHistory: build.query<
            GetApiV1ClientPaymentsGetUserPurchasesHistoryApiResponse,
            GetApiV1ClientPaymentsGetUserPurchasesHistoryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/GetUserPurchasesHistory`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        postApiV1ClientPaymentsInitializeSubscribeToPlanPayment: build.mutation<
            PostApiV1ClientPaymentsInitializeSubscribeToPlanPaymentApiResponse,
            PostApiV1ClientPaymentsInitializeSubscribeToPlanPaymentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Payments/InitializeSubscribeToPlanPayment`,
                method: 'POST',
                params: {
                    planId: queryArg.planId,
                },
            }),
        }),
        getApiV1ClientPlans: build.query<GetApiV1ClientPlansApiResponse, GetApiV1ClientPlansApiArg>(
            {
                query: (queryArg) => ({
                    url: `/api/v1/client/Plans`,
                    params: {
                        pageNumber: queryArg.pageNumber,
                        pageSize: queryArg.pageSize,
                        isPaginated: queryArg.isPaginated,
                    },
                }),
            },
        ),
        patchApiV1ClientPlansCancelSubscriptionById: build.mutation<
            PatchApiV1ClientPlansCancelSubscriptionByIdApiResponse,
            PatchApiV1ClientPlansCancelSubscriptionByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Plans/CancelSubscription/${queryArg.id}`,
                method: 'PATCH',
            }),
        }),
        getApiV1ClientResidentialComplexes: build.query<
            GetApiV1ClientResidentialComplexesApiResponse,
            GetApiV1ClientResidentialComplexesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/ResidentialComplexes`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientResidentialComplexesById: build.query<
            GetApiV1ClientResidentialComplexesByIdApiResponse,
            GetApiV1ClientResidentialComplexesByIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/client/ResidentialComplexes/${queryArg.id}` }),
        }),
        getApiV1ClientSliders: build.query<
            GetApiV1ClientSlidersApiResponse,
            GetApiV1ClientSlidersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Sliders`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientSpecifications: build.query<
            GetApiV1ClientSpecificationsApiResponse,
            GetApiV1ClientSpecificationsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Specifications`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                },
            }),
        }),
        getApiV1ClientTargets: build.query<
            GetApiV1ClientTargetsApiResponse,
            GetApiV1ClientTargetsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/Targets`,
                params: {
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                    isPaginated: queryArg.isPaginated,
                    cityId: queryArg.cityId,
                },
            }),
        }),
        postApiV1ClientUserFavoritesAddToFavoriteById: build.mutation<
            PostApiV1ClientUserFavoritesAddToFavoriteByIdApiResponse,
            PostApiV1ClientUserFavoritesAddToFavoriteByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/UserFavorites/AddToFavorite/${queryArg.id}`,
                method: 'POST',
            }),
        }),
        postApiV1ClientUserFavoritesRemoveFromFavoriteById: build.mutation<
            PostApiV1ClientUserFavoritesRemoveFromFavoriteByIdApiResponse,
            PostApiV1ClientUserFavoritesRemoveFromFavoriteByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/UserFavorites/RemoveFromFavorite/${queryArg.id}`,
                method: 'POST',
            }),
        }),
        getApiV1ClientUserFavoritesGetUserFavorites: build.query<
            GetApiV1ClientUserFavoritesGetUserFavoritesApiResponse,
            GetApiV1ClientUserFavoritesGetUserFavoritesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/UserFavorites/GetUserFavorites`,
                params: {
                    pageSize: queryArg.pageSize,
                    pageNumber: queryArg.pageNumber,
                },
            }),
        }),
        getApiV1ClientUserFavoritesGetFavorites: build.query<
            GetApiV1ClientUserFavoritesGetFavoritesApiResponse,
            GetApiV1ClientUserFavoritesGetFavoritesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/UserFavorites/GetFavorites`,
                params: {
                    adsIds: queryArg.adsIds,
                    pageSize: queryArg.pageSize,
                    pageNumber: queryArg.pageNumber,
                },
            }),
        }),
        postApiV1ClientUserFavoritesAddUserFavorites: build.mutation<
            PostApiV1ClientUserFavoritesAddUserFavoritesApiResponse,
            PostApiV1ClientUserFavoritesAddUserFavoritesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/client/UserFavorites/AddUserFavorites`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getApiV1ClientUserFavoritesGetUserFavoriteAdsIds: build.query<
            GetApiV1ClientUserFavoritesGetUserFavoriteAdsIdsApiResponse,
            GetApiV1ClientUserFavoritesGetUserFavoriteAdsIdsApiArg
        >({
            query: () => ({ url: `/api/v1/client/UserFavorites/GetUserFavoriteAdsIds` }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as allApis };
export type GetApiV1ClientAdFeaturesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsFeatureDtOsAdsFeatureGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientAdFeaturesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientAdFeaturesByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsAdsFeatureDtOsAdsFeatureGetDto;
export type GetApiV1ClientAdFeaturesByIdApiArg = {
    id: string;
};
export type GetApiV1ClientAdFeaturesGetPricingByIdByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePricingGetDto;
export type GetApiV1ClientAdFeaturesGetPricingByIdByIdApiArg = {
    id: string;
};
export type GetApiV1ClientAdsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsDtOsAdsGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientAdsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    status?: DarxDomainEnumsAdsStatus;
    propertyType?: DarxDomainEnumsPropertyType;
    maintenanceStatuses?: DarxDomainEnumsMaintenanceStatus[];
    advertOwnerType?: DarxDomainEnumsAdvertOwnerType;
    advertType?: DarxDomainEnumsAdvertType;
    documentStatus?: DarxDomainEnumsDocumentStatus;
    mortgageStatus?: DarxDomainEnumsMortgageStatus;
    priceType?: DarxDomainEnumsPriceType;
    buildingType?: DarxDomainEnumsBuildingType;
    minPrice?: number;
    maxPrice?: number;
    minPropertyArea?: number;
    maxPropertyArea?: number;
    minPropertyFloor?: number;
    maxPropertyFloor?: number;
    countryIds?: string[];
    cityIds?: string[];
    districtIds?: string[];
    metroIds?: string[];
    targetIds?: string[];
    roomCount?: number;
    sortByPrimary?: string;
    sortDirectionPrimary?: string;
    sortBySecondary?: string;
    sortDirectionSecondary?: string;
    agencyId?: string;
    isVip?: boolean;
    isPremium?: boolean;
};
export type PostApiV1ClientAdsApiResponse = unknown;
export type PostApiV1ClientAdsApiArg = {
    body: {
        AdvertOwnerType?: DarxDomainEnumsAdvertOwnerType;
        AdvertType: DarxDomainEnumsAdvertType;
        PropertyType: DarxDomainEnumsPropertyType;
        MaintenanceStatus?: DarxDomainEnumsMaintenanceStatus;
        DocumentStatus?: DarxDomainEnumsDocumentStatus;
        MortgageStatus?: DarxDomainEnumsMortgageStatus;
        PriceType?: DarxDomainEnumsPriceType;
        PropertyArea?: number;
        Price?: number;
        RoomCount?: number;
        BuildingType?: DarxDomainEnumsBuildingType;
        BuildingFloorCount?: number;
        PropertyFloor?: number;
        Description?: string;
        Images?: DarxApplicationDtOsAdsDtOsAdsImagePostDto[];
        AdsVideos?: DarxApplicationDtOsAdsDtOsAdsVideoPostDto[];
        CountryId?: string;
        CityId?: string;
        DistrictId?: string;
        MetroId?: string;
        TargetId?: string;
        Name?: string;
        Surname?: string;
        Email?: string;
        PhoneNumber?: string;
        PropertyLandArea?: number;
        Latitude?: string;
        Longitude?: string;
        payWithBalance?: boolean;
    };
};
export type GetApiV1ClientAdsGetAllCurrentUserAdsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsDtOsAdsGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientAdsGetAllCurrentUserAdsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    status?: DarxDomainEnumsAdsStatus;
};
export type GetApiV1ClientAdsByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsAdsDtOsAdsGetDto;
export type GetApiV1ClientAdsByIdApiArg = {
    id: number;
};
export type PutApiV1ClientAdsByIdApiResponse = unknown;
export type PutApiV1ClientAdsByIdApiArg = {
    id: number;
    body: {
        AdvertOwnerType?: DarxDomainEnumsAdvertOwnerType;
        AdvertType: DarxDomainEnumsAdvertType;
        PropertyType: DarxDomainEnumsPropertyType;
        MaintenanceStatus?: DarxDomainEnumsMaintenanceStatus;
        DocumentStatus?: DarxDomainEnumsDocumentStatus;
        MortgageStatus?: DarxDomainEnumsMortgageStatus;
        PriceType?: DarxDomainEnumsPriceType;
        PropertyArea?: number;
        Price?: number;
        RoomCount?: number;
        BuildingType?: DarxDomainEnumsBuildingType;
        BuildingFloorCount?: number;
        PropertyFloor?: number;
        Description?: string;
        Images?: DarxApplicationDtOsAdsDtOsAdsImageUpdateDto[];
        AdsVideos?: DarxApplicationDtOsAdsDtOsAdsVideoUpdateDto[];
        CountryId?: string;
        CityId?: string;
        DistrictId?: string;
        MetroId?: string;
        TargetId?: string;
        Name?: string;
        Surname?: string;
        Email?: string;
        PhoneNumber?: string;
        PropertyLandArea?: number;
        Latitude?: string;
        Longitude?: string;
    };
};
export type DeleteApiV1ClientAdsByIdApiResponse = unknown;
export type DeleteApiV1ClientAdsByIdApiArg = {
    id: number;
};
export type GetApiV1ClientAdsGetUserBalanceApiResponse = unknown;
export type GetApiV1ClientAdsGetUserBalanceApiArg = void;
export type PutApiV1ClientAdsReactivateAdsByIdApiResponse = unknown;
export type PutApiV1ClientAdsReactivateAdsByIdApiArg = {
    id: number;
    payWithBalance?: boolean;
};
export type GetApiV1ClientAdsCreateRoleApiResponse = unknown;
export type GetApiV1ClientAdsCreateRoleApiArg = void;
export type GetApiV1ClientAdsByIdPdfApiResponse = unknown;
export type GetApiV1ClientAdsByIdPdfApiArg = {
    id: number;
    withContact?: boolean;
};
export type GetApiV1ClientAdvertisementsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdvertisementDtOsAdvertisementGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientAdvertisementsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientAgenciesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsIdentityDtOsAdminAgencyUserGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientAgenciesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientAgenciesByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsIdentityDtOsAdminAgencyUserGetDto;
export type GetApiV1ClientAgenciesByIdApiArg = {
    id: string;
};
export type PostApiV1ClientAuthResetPasswordApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsGeneralResponse601DarxApplicationDtOsAuthDtOsResetTokenEmailResponseDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type PostApiV1ClientAuthResetPasswordApiArg = {
    darxApplicationDtOsAuthDtOsResetPasswordDto: DarxApplicationDtOsAuthDtOsResetPasswordDto;
};
export type GetApiV1ClientAuthVerifyPasswordResetTokenApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsBaseReponse;
export type GetApiV1ClientAuthVerifyPasswordResetTokenApiArg = {
    userId?: string;
    resetToken?: string;
};
export type PostApiV1ClientAuthUpdatePasswordAsyncApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsBaseReponse;
export type PostApiV1ClientAuthUpdatePasswordAsyncApiArg = {
    darxApplicationDtOsAuthDtOsUpdatePasswordDto: DarxApplicationDtOsAuthDtOsUpdatePasswordDto;
};
export type GetApiV1ClientAuthRefreshTokenLoginAsyncApiResponse =
    /** status 200 OK */ DarxApplicationDtOsTokenDtOsTokenResponseDto;
export type GetApiV1ClientAuthRefreshTokenLoginAsyncApiArg = {
    refreshToken?: string;
};
export type GetApiV1ClientBlogsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBlogDtOsBlogGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientBlogsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientBlogsByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBlogDtOsBlogGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientBlogsByIdApiArg = {
    id: string;
};
export type GetApiV1ClientBuildingTypesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBuildingTypeDtOsBuildingTypeGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientBuildingTypesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientCitiesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCityDtOsCityGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientCitiesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    countryId?: string;
};
export type PostApiV1ClientContactsCallMeApiResponse = unknown;
export type PostApiV1ClientContactsCallMeApiArg = {
    darxApplicationDtOsContactsDtoCallMeRequestDto: DarxApplicationDtOsContactsDtoCallMeRequestDto;
};
export type GetApiV1ClientCountriesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCountryDtOsCountryGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientCountriesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientCurrenciesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCurrencyDtOsCurrencyGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientCurrenciesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientCurrenciesByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCurrencyDtOsCurrencyGetDto;
export type GetApiV1ClientCurrenciesByIdApiArg = {
    id: string;
};
export type GetApiV1ClientDistrictsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsDistrictDtOsDistrictGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientDistrictsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    cityId?: string;
};
export type PostApiV1ClientIdentityRegisterApiResponse = unknown;
export type PostApiV1ClientIdentityRegisterApiArg = {
    darxApplicationDtOsIdentityDtOsRegisterDto: DarxApplicationDtOsIdentityDtOsRegisterDto;
};
export type PutApiV1ClientIdentityUpdateApiResponse = unknown;
export type PutApiV1ClientIdentityUpdateApiArg = {
    body: {
        Name?: string;
        Surname?: string;
        Email?: string;
        PhoneNumber?: string;
        WhatsappPhoneNumber?: string;
        TelegramUserName?: string;
        AgencyName?: string;
        File?: Blob;
        AgencyDescription?: string;
    };
};
export type GetApiV1ClientIdentityGetCurrentUserApiResponse = unknown;
export type GetApiV1ClientIdentityGetCurrentUserApiArg = void;
export type PostApiV1ClientIdentityLoginApiResponse = unknown;
export type PostApiV1ClientIdentityLoginApiArg = {
    darxApplicationDtOsIdentityDtOsLoginDto: DarxApplicationDtOsIdentityDtOsLoginDto;
};
export type PostApiV1ClientIdentitySendOtpApiResponse = unknown;
export type PostApiV1ClientIdentitySendOtpApiArg = {
    phoneNumber?: string;
};
export type PostApiV1ClientIdentityVerifyOtpApiResponse = unknown;
export type PostApiV1ClientIdentityVerifyOtpApiArg = {
    phoneNumber?: string;
    otpCode?: number;
};
export type PostApiV1ClientIdentityVerifyOtpForAdsApiResponse = unknown;
export type PostApiV1ClientIdentityVerifyOtpForAdsApiArg = {
    phoneNumber?: string;
    otpCode?: number;
};
export type GetApiV1ClientLanguagesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsGeneralResponse601SystemCollectionsGenericIEnumerable601DarxApplicationDtOsLanguageDtOsLanguageGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull20SystemPrivateCoreLib20Version800020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
export type GetApiV1ClientLanguagesApiArg = void;
export type GetApiV1ClientMetrosApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsMetroDtOsMetroGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientMetrosApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    cityId?: string;
};
export type PostApiV1ClientPaymentsInitializeAdsUpgradePaymentApiResponse = unknown;
export type PostApiV1ClientPaymentsInitializeAdsUpgradePaymentApiArg = {
    adsId?: number;
    adFueaturePricingId?: string;
};
export type PostApiV1ClientPaymentsInitializeIncreaseBalancePaymentApiResponse = unknown;
export type PostApiV1ClientPaymentsInitializeIncreaseBalancePaymentApiArg = {
    amount?: number;
};
export type PostApiV1ClientPaymentsInitializePayWithBalancePaymentApiResponse = unknown;
export type PostApiV1ClientPaymentsInitializePayWithBalancePaymentApiArg = {
    adsId?: number;
    adFueaturePricingId?: string;
};
export type GetApiV1ClientPaymentsVerifyPaymentApiResponse = unknown;
export type GetApiV1ClientPaymentsVerifyPaymentApiArg = {
    transaction?: string;
};
export type GetApiV1ClientPaymentsGetUserPurchasesHistoryApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePurchaseGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientPaymentsGetUserPurchasesHistoryApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type PostApiV1ClientPaymentsInitializeSubscribeToPlanPaymentApiResponse = unknown;
export type PostApiV1ClientPaymentsInitializeSubscribeToPlanPaymentApiArg = {
    planId?: string;
};
export type GetApiV1ClientPlansApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsPlanDtOsPlanGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientPlansApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type PatchApiV1ClientPlansCancelSubscriptionByIdApiResponse = unknown;
export type PatchApiV1ClientPlansCancelSubscriptionByIdApiArg = {
    id: string;
};
export type GetApiV1ClientResidentialComplexesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientResidentialComplexesApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientResidentialComplexesByIdApiResponse =
    /** status 200 OK */ DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetDto;
export type GetApiV1ClientResidentialComplexesByIdApiArg = {
    id: string;
};
export type GetApiV1ClientSlidersApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsSliderDtOsSliderGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientSlidersApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientSpecificationsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsSpecificationDtOsSpecificationGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientSpecificationsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
};
export type GetApiV1ClientTargetsApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsTargetDtOsTargetGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientTargetsApiArg = {
    pageNumber?: number;
    pageSize?: number;
    isPaginated?: boolean;
    cityId?: string;
};
export type PostApiV1ClientUserFavoritesAddToFavoriteByIdApiResponse = unknown;
export type PostApiV1ClientUserFavoritesAddToFavoriteByIdApiArg = {
    id: number;
};
export type PostApiV1ClientUserFavoritesRemoveFromFavoriteByIdApiResponse = unknown;
export type PostApiV1ClientUserFavoritesRemoveFromFavoriteByIdApiArg = {
    id: number;
};
export type GetApiV1ClientUserFavoritesGetUserFavoritesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsDtOsAdsGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientUserFavoritesGetUserFavoritesApiArg = {
    pageSize?: number;
    pageNumber?: number;
};
export type GetApiV1ClientUserFavoritesGetFavoritesApiResponse =
    /** status 200 OK */ DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsDtOsAdsGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull;
export type GetApiV1ClientUserFavoritesGetFavoritesApiArg = {
    adsIds?: string;
    pageSize?: number;
    pageNumber?: number;
};
export type PostApiV1ClientUserFavoritesAddUserFavoritesApiResponse = unknown;
export type PostApiV1ClientUserFavoritesAddUserFavoritesApiArg = {
    body: number[];
};
export type GetApiV1ClientUserFavoritesGetUserFavoriteAdsIdsApiResponse =
    /** status 200 OK */ number[];
export type GetApiV1ClientUserFavoritesGetUserFavoriteAdsIdsApiArg = void;
export type DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePricingGetDto = {
    id?: string;
    adsFeatureId?: string;
    durationInDays?: number;
    price?: number;
};
export type DarxApplicationDtOsAdsFeatureDtOsAdsFeatureGetDto = {
    id?: string;
    name?: string | null;
    pricings?: DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePricingGetDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsFeatureDtOsAdsFeatureGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsAdsFeatureDtOsAdsFeatureGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type MicrosoftAspNetCoreMvcProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
};
export type DarxApplicationDtOsAdsDtOsAdsImageGetDto = {
    id?: string;
    largeImage?: string | null;
    smallImage?: string | null;
    index?: number;
    rotate?: number;
};
export type DarxDomainEnumsMaintenanceStatus = 'Full' | 'Average' | 'Bad';
export type DarxDomainEnumsAdvertOwnerType = 'Owner' | 'Agency' | 'Intermediary';
export type DarxDomainEnumsAdvertType = 'Rent' | 'Sale';
export type DarxDomainEnumsPropertyType =
    | 'NewBuilding'
    | 'OldBuilding'
    | 'YardHouse'
    | 'Office'
    | 'Garage'
    | 'Land'
    | 'Commercial';
export type DarxDomainEnumsDocumentStatus = 'Yes' | 'No';
export type DarxDomainEnumsMortgageStatus = 'Yes' | 'No';
export type DarxDomainEnumsPriceType = 'Monthly' | 'Daily';
export type DarxDomainEnumsAdsStatus = 'Pending' | 'Expired' | 'Active' | 'Rejected';
export type DarxDomainEnumsBuildingType = 'BusinessCenter' | 'Home' | 'Villa';
export type DarxApplicationDtOsCountryDtOsCountryDictionaryGetAllDto = {
    id?: string;
    name?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsCountryDtOsCountryGetDto = {
    id?: string;
    image?: string | null;
    countryDictionaryGetAllDtos?: DarxApplicationDtOsCountryDtOsCountryDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCityDtOsCityDictionaryGetAllDto = {
    id?: string;
    name?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsCityDtOsCityGetDto = {
    id?: string;
    countryId?: string;
    cityDictionaryGetAllDtos?: DarxApplicationDtOsCityDtOsCityDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsDistrictDtOsDistrictDictionaryGetAllDto = {
    id?: string;
    name?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsDistrictDtOsDistrictGetDto = {
    id?: string;
    cityId?: string;
    districtDictionaryGetAllDtos?:
        | DarxApplicationDtOsDistrictDtOsDistrictDictionaryGetAllDto[]
        | null;
};
export type DarxApplicationDtOsMetroDtOsMetroDictionaryGetAllDto = {
    id?: string;
    name?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsMetroDtOsMetroGetDto = {
    id?: string;
    cityId?: string;
    metroDictionaryGetAllDtos?: DarxApplicationDtOsMetroDtOsMetroDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsTargetDtOsTargetDictionaryGetAllDto = {
    id?: string;
    name?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsTargetDtOsTargetGetDto = {
    id?: string;
    cityId?: string;
    targetDictionaryGetAllDtos?: DarxApplicationDtOsTargetDtOsTargetDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsAdsDtOsAdsUserGetDto = {
    userId?: string | null;
    phoneNumber?: string | null;
    whatsappPhoneNumber?: string | null;
    telegramUserName?: string | null;
    image?: string | null;
    agencyDescription?: string | null;
    agencyName?: string | null;
    isAgency?: boolean;
};
export type DarxApplicationDtOsAdsDtOsAdsGetAllDto = {
    id?: number;
    images?: DarxApplicationDtOsAdsDtOsAdsImageGetDto[] | null;
    districtOrMetro?: string | null;
    maintenanceStatus?: DarxDomainEnumsMaintenanceStatus;
    price?: number | null;
    roomCount?: number | null;
    propertyArea?: number | null;
    propertyFloor?: number | null;
    latitude?: string | null;
    longitude?: string | null;
    date?: string | null;
    appUserId?: string | null;
    ownerImage?: string | null;
    name?: string | null;
    surname?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    propertyLandArea?: number | null;
    buildingFloorCount?: number | null;
    description?: string | null;
    advertOwnerType?: DarxDomainEnumsAdvertOwnerType;
    advertType?: DarxDomainEnumsAdvertType;
    propertyType?: DarxDomainEnumsPropertyType;
    documentStatus?: DarxDomainEnumsDocumentStatus;
    mortgageStatus?: DarxDomainEnumsMortgageStatus;
    priceType?: DarxDomainEnumsPriceType;
    adsStatus?: DarxDomainEnumsAdsStatus;
    buildingType?: DarxDomainEnumsBuildingType;
    country?: DarxApplicationDtOsCountryDtOsCountryGetDto;
    city?: DarxApplicationDtOsCityDtOsCityGetDto;
    district?: DarxApplicationDtOsDistrictDtOsDistrictGetDto;
    metro?: DarxApplicationDtOsMetroDtOsMetroGetDto;
    target?: DarxApplicationDtOsTargetDtOsTargetGetDto;
    rejectNote?: string | null;
    userDto?: DarxApplicationDtOsAdsDtOsAdsUserGetDto;
    isVIP?: boolean;
    vipExpireDate?: string | null;
    isPremium?: boolean;
    premiumExpireDate?: string | null;
    forwardExpireDate?: string | null;
    expirationDate?: string;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsDtOsAdsGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsAdsDtOsAdsGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsAdsDtOsAdsImagePostDto = {
    image?: Blob | null;
    index?: number;
    rotate?: number;
    largeImagePath?: string | null;
    smallImagePath?: string | null;
};
export type DarxApplicationDtOsAdsDtOsAdsVideoPostDto = {
    video?: Blob | null;
    index?: number;
    videoPath?: string | null;
};
export type DarxApplicationDtOsAdsDtOsAdsVideoGetDto = {
    id?: string;
    video?: string | null;
    index?: number;
};
export type DarxApplicationDtOsAdsDtOsAdsGetDto = {
    id?: number;
    appUserId?: string | null;
    advertOwnerType?: DarxDomainEnumsAdvertOwnerType;
    advertType?: DarxDomainEnumsAdvertType;
    propertyType?: DarxDomainEnumsPropertyType;
    maintenanceStatus?: DarxDomainEnumsMaintenanceStatus;
    documentStatus?: DarxDomainEnumsDocumentStatus;
    mortgageStatus?: DarxDomainEnumsMortgageStatus;
    priceType?: DarxDomainEnumsPriceType;
    adsStatus?: DarxDomainEnumsAdsStatus;
    propertyArea?: number | null;
    price?: number | null;
    roomCount?: number | null;
    buildingType?: DarxDomainEnumsBuildingType;
    buildingFloorCount?: number | null;
    propertyFloor?: number | null;
    description?: string | null;
    images?: DarxApplicationDtOsAdsDtOsAdsImageGetDto[] | null;
    adsVideos?: DarxApplicationDtOsAdsDtOsAdsVideoGetDto[] | null;
    country?: DarxApplicationDtOsCountryDtOsCountryGetDto;
    city?: DarxApplicationDtOsCityDtOsCityGetDto;
    district?: DarxApplicationDtOsDistrictDtOsDistrictGetDto;
    metro?: DarxApplicationDtOsMetroDtOsMetroGetDto;
    target?: DarxApplicationDtOsTargetDtOsTargetGetDto;
    ownerImage?: string | null;
    name?: string | null;
    surname?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    propertyLandArea?: number | null;
    dateForOrder?: string;
    latitude?: string | null;
    longitude?: string | null;
    rejectNote?: string | null;
    userDto?: DarxApplicationDtOsAdsDtOsAdsUserGetDto;
    isVIP?: boolean;
    vipExpireDate?: string | null;
    isPremium?: boolean;
    premiumExpireDate?: string | null;
    forwardExpireDate?: string | null;
    expirationDate?: string;
};
export type DarxApplicationDtOsAdsDtOsAdsImageUpdateDto = {
    existingImageId?: string | null;
    image?: Blob | null;
    index?: number;
    rotate?: number;
};
export type DarxApplicationDtOsAdsDtOsAdsVideoUpdateDto = {
    existingVideoId?: string | null;
    video?: Blob | null;
    index?: number;
};
export type DarxApplicationDtOsAdvertisementDtOsAdvertisementGetAllDto = {
    id?: string;
    url?: string | null;
    image?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdvertisementDtOsAdvertisementGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsAdvertisementDtOsAdvertisementGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsPlanDtOsPlanGetDto = {
    id?: string;
    name?: string | null;
    price?: number;
    maxPosts?: number;
    hasAdDiscount?: boolean;
    hasPromotion?: boolean;
    discountPercentage?: number;
    durationInDays?: number;
    planBalanceForPurchases?: number;
    expireDate?: string;
    remainPlanAdsCount?: number;
};
export type DarxApplicationDtOsIdentityDtOsAdminAgencyUserGetDto = {
    id?: string | null;
    name?: string | null;
    surname?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    whatsappPhoneNumber?: string | null;
    telegramUserName?: string | null;
    agencyName?: string | null;
    isBlocked?: boolean;
    workTime?: string | null;
    adress?: string | null;
    image?: string | null;
    agencyDescription?: string | null;
    adsCount?: number;
    planPostCounter?: number;
    plan?: DarxApplicationDtOsPlanDtOsPlanGetDto;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsIdentityDtOsAdminAgencyUserGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsIdentityDtOsAdminAgencyUserGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsAuthDtOsResetTokenEmailResponseDto = {
    token?: string | null;
    email?: string | null;
    userId?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsGeneralResponse601DarxApplicationDtOsAuthDtOsResetTokenEmailResponseDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        message?: string | null;
        statusCode?: number;
        id?: string;
        id2?: string | null;
        data?: DarxApplicationDtOsAuthDtOsResetTokenEmailResponseDto;
        url?: string | null;
    };
export type DarxApplicationDtOsAuthDtOsResetPasswordDto = {
    email?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsBaseReponse = {
    message?: string | null;
    statusCode?: number;
    id?: string;
    id2?: string | null;
};
export type DarxApplicationDtOsAuthDtOsUpdatePasswordDto = {
    userId?: string | null;
    resetToken?: string | null;
    newPassword?: string | null;
    confirmedNewPassword?: string | null;
};
export type DarxApplicationDtOsTokenDtOsTokenResponseDto = {
    accessToken?: string | null;
    expiration?: string;
    refreshToken?: string | null;
};
export type DarxApplicationDtOsBlogDtOsBlogDictionaryGetAllDto = {
    id?: string;
    title?: string | null;
    description?: string | null;
    miniDescription?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsBlogDtOsBlogGetAllDto = {
    id?: string;
    title?: string | null;
    description?: string | null;
    miniDescription?: string | null;
    blogDictionaryGetAllDtos?: DarxApplicationDtOsBlogDtOsBlogDictionaryGetAllDto[] | null;
    createAt?: string;
    image?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBlogDtOsBlogGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsBlogDtOsBlogGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsBlogDtOsBlogGetDto = {
    id?: string;
    image?: string | null;
    createAt?: string;
    blogDictionaryGetAllDtos?: DarxApplicationDtOsBlogDtOsBlogDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBlogDtOsBlogGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsBlogDtOsBlogGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsBuildingTypeDtOsBuildingTypeGetAllDto = {
    id?: string;
    name?: string | null;
    icon?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsBuildingTypeDtOsBuildingTypeGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsBuildingTypeDtOsBuildingTypeGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsCityDtOsCityGetAllDto = {
    id?: string;
    name?: string | null;
    cityDictionaryGetAllDtos?: DarxApplicationDtOsCityDtOsCityDictionaryGetAllDto[] | null;
    countryId?: string;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCityDtOsCityGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsCityDtOsCityGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsContactsDtoCallMeRequestDto = {
    phoneOrEmailAdress?: string | null;
};
export type DarxApplicationDtOsCountryDtOsCountryGetAllDto = {
    id?: string;
    name?: string | null;
    image?: string | null;
    countryDictionaryGetAllDtos?: DarxApplicationDtOsCountryDtOsCountryDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCountryDtOsCountryGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsCountryDtOsCountryGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsCurrencyDtOsCurrencyGetDto = {
    id?: string;
    code?: string | null;
    name?: string | null;
    symbol?: string | null;
    exchangeRate?: number;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsCurrencyDtOsCurrencyGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsCurrencyDtOsCurrencyGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsDistrictDtOsDistrictGetAllDto = {
    id?: string;
    name?: string | null;
    cityId?: string;
    districtDictionaryGetAllDtos?:
        | DarxApplicationDtOsDistrictDtOsDistrictDictionaryGetAllDto[]
        | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsDistrictDtOsDistrictGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsDistrictDtOsDistrictGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsIdentityDtOsRegisterDto = {
    name?: string | null;
    surname?: string | null;
    phoneNumber?: string | null;
};
export type DarxApplicationDtOsIdentityDtOsLoginDto = {
    email?: string | null;
    password?: string | null;
};
export type DarxApplicationDtOsLanguageDtOsLanguageGetDto = {
    id?: string;
    code?: string | null;
    name?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsGeneralResponse601SystemCollectionsGenericIEnumerable601DarxApplicationDtOsLanguageDtOsLanguageGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull20SystemPrivateCoreLib20Version800020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    {
        message?: string | null;
        statusCode?: number;
        id?: string;
        id2?: string | null;
        data?: DarxApplicationDtOsLanguageDtOsLanguageGetDto[] | null;
        url?: string | null;
    };
export type DarxApplicationDtOsMetroDtOsMetroGetAllDto = {
    id?: string;
    name?: string | null;
    cityId?: string;
    metroDictionaryGetAllDtos?: DarxApplicationDtOsMetroDtOsMetroDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsMetroDtOsMetroGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsMetroDtOsMetroGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxDomainEnumsTransactionType = 'WithMoney' | 'WithUserBalance';
export type DarxDomainEnumsTransactionOperationType =
    | 'MakeVipAd'
    | 'MakePremiumAd'
    | 'ForwardAd'
    | 'IncreaseBalance'
    | 'SubscribeToPlan'
    | 'PostAds'
    | 'ReactivateAds';
export type DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePurchaseGetDto = {
    adsId?: number | null;
    adsFeatureId?: string | null;
    transaction?: string | null;
    successStatus?: boolean;
    purchaseDate?: string;
    expirationDate?: string | null;
    phoneNumber?: string | null;
    totalPrice?: number;
    transactionType?: DarxDomainEnumsTransactionType;
    transactionOperationType?: DarxDomainEnumsTransactionOperationType;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePurchaseGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsAdsFeatureDtOsAdsFeaturePurchaseGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsPlanDtOsPlanGetDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsPlanDtOsPlanGetDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsSuggestionDtOsSuggestionGetDto = {
    id?: string;
    price?: number;
    imageUrl?: string | null;
    roomCount?: number | null;
    area?: number | null;
    balconyCount?: number | null;
    sanitaryFacilityCount?: number | null;
};
export type DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetAllDto = {
    id?: string;
    title?: string | null;
    minPrice?: number;
    adress?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    mainImage?: string | null;
    deliveryDate?: string | null;
    logoImage?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;
    whatsappPhoneNumber?: string | null;
    telegramAdress?: string | null;
    suggestions?: DarxApplicationDtOsSuggestionDtOsSuggestionGetDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsSpecificationDtOsSpecificationDictionaryGetDto = {
    id?: string;
    title?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsResidentialComplexDtOsResidentialComplexSpecificationGetDto = {
    id?: string;
    value?: string | null;
    labels?: DarxApplicationDtOsSpecificationDtOsSpecificationDictionaryGetDto[] | null;
    icon?: string | null;
    specificationId?: string;
};
export type DarxApplicationDtOsResidentialComplexDtOsResidentialComplexGetDto = {
    id?: string;
    title?: string | null;
    minPrice?: number;
    adress?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    mainImage?: string | null;
    deliveryDate?: string | null;
    logoImage?: string | null;
    workTime?: string | null;
    phoneNumber?: string | null;
    whatsappPhoneNumber?: string | null;
    telegramAdress?: string | null;
    residentialComplexSpecificationGetDtos?:
        | DarxApplicationDtOsResidentialComplexDtOsResidentialComplexSpecificationGetDto[]
        | null;
    suggestions?: DarxApplicationDtOsSuggestionDtOsSuggestionGetDto[] | null;
};
export type DarxApplicationDtOsSliderDtOsSliderDictionaryGetAllDto = {
    id?: string;
    title?: string | null;
    description?: string | null;
    languageId?: string;
};
export type DarxApplicationDtOsSliderDtOsSliderGetAllDto = {
    id?: string;
    title?: string | null;
    description?: string | null;
    image?: string | null;
    redirectUrl?: string | null;
    sliderDictionaryGetAllDtos?: DarxApplicationDtOsSliderDtOsSliderDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsSliderDtOsSliderGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsSliderDtOsSliderGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsSpecificationDtOsSpecificationGetAllDto = {
    id?: string;
    title?: string | null;
    icon?: string | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsSpecificationDtOsSpecificationGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsSpecificationDtOsSpecificationGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export type DarxApplicationDtOsTargetDtOsTargetGetAllDto = {
    id?: string;
    name?: string | null;
    cityId?: string;
    targetDictionaryGetAllDtos?: DarxApplicationDtOsTargetDtOsTargetDictionaryGetAllDto[] | null;
};
export type DarxApplicationDtOsCommonResponsesDtOsPaginatedResponse601DarxApplicationDtOsTargetDtOsTargetGetAllDto20DarxApplication20Version100020CultureNeutral20PublicKeyTokenNull =
    {
        items?: DarxApplicationDtOsTargetDtOsTargetGetAllDto[] | null;
        totalItems?: number;
        pageNumber?: number;
        pageSize?: number;
        totalPages?: number;
        additionalInfo?: {
            [key: string]: any;
        } | null;
    };
export const {
    useGetApiV1ClientAdFeaturesQuery,
    useGetApiV1ClientAdFeaturesByIdQuery,
    useGetApiV1ClientAdFeaturesGetPricingByIdByIdQuery,
    useGetApiV1ClientAdsQuery,
    usePostApiV1ClientAdsMutation,
    useGetApiV1ClientAdsGetAllCurrentUserAdsQuery,
    useGetApiV1ClientAdsByIdQuery,
    usePutApiV1ClientAdsByIdMutation,
    useDeleteApiV1ClientAdsByIdMutation,
    useGetApiV1ClientAdsGetUserBalanceQuery,
    usePutApiV1ClientAdsReactivateAdsByIdMutation,
    useGetApiV1ClientAdsCreateRoleQuery,
    useGetApiV1ClientAdsByIdPdfQuery,
    useGetApiV1ClientAdvertisementsQuery,
    useGetApiV1ClientAgenciesQuery,
    useGetApiV1ClientAgenciesByIdQuery,
    usePostApiV1ClientAuthResetPasswordMutation,
    useGetApiV1ClientAuthVerifyPasswordResetTokenQuery,
    usePostApiV1ClientAuthUpdatePasswordAsyncMutation,
    useGetApiV1ClientAuthRefreshTokenLoginAsyncQuery,
    useGetApiV1ClientBlogsQuery,
    useGetApiV1ClientBlogsByIdQuery,
    useGetApiV1ClientBuildingTypesQuery,
    useGetApiV1ClientCitiesQuery,
    usePostApiV1ClientContactsCallMeMutation,
    useGetApiV1ClientCountriesQuery,
    useGetApiV1ClientCurrenciesQuery,
    useGetApiV1ClientCurrenciesByIdQuery,
    useGetApiV1ClientDistrictsQuery,
    usePostApiV1ClientIdentityRegisterMutation,
    usePutApiV1ClientIdentityUpdateMutation,
    useGetApiV1ClientIdentityGetCurrentUserQuery,
    usePostApiV1ClientIdentityLoginMutation,
    usePostApiV1ClientIdentitySendOtpMutation,
    usePostApiV1ClientIdentityVerifyOtpMutation,
    usePostApiV1ClientIdentityVerifyOtpForAdsMutation,
    useGetApiV1ClientLanguagesQuery,
    useGetApiV1ClientMetrosQuery,
    usePostApiV1ClientPaymentsInitializeAdsUpgradePaymentMutation,
    usePostApiV1ClientPaymentsInitializeIncreaseBalancePaymentMutation,
    usePostApiV1ClientPaymentsInitializePayWithBalancePaymentMutation,
    useGetApiV1ClientPaymentsVerifyPaymentQuery,
    useGetApiV1ClientPaymentsGetUserPurchasesHistoryQuery,
    usePostApiV1ClientPaymentsInitializeSubscribeToPlanPaymentMutation,
    useGetApiV1ClientPlansQuery,
    usePatchApiV1ClientPlansCancelSubscriptionByIdMutation,
    useGetApiV1ClientResidentialComplexesQuery,
    useGetApiV1ClientResidentialComplexesByIdQuery,
    useGetApiV1ClientSlidersQuery,
    useGetApiV1ClientSpecificationsQuery,
    useGetApiV1ClientTargetsQuery,
    usePostApiV1ClientUserFavoritesAddToFavoriteByIdMutation,
    usePostApiV1ClientUserFavoritesRemoveFromFavoriteByIdMutation,
    useGetApiV1ClientUserFavoritesGetUserFavoritesQuery,
    useGetApiV1ClientUserFavoritesGetFavoritesQuery,
    usePostApiV1ClientUserFavoritesAddUserFavoritesMutation,
    useGetApiV1ClientUserFavoritesGetUserFavoriteAdsIdsQuery,
} = injectedRtkApi;
